import immerHandleActions from 'redux/utils/immerHandleActions';

import { setWCMAppConfigAction, setWCMAppConfig } from './actions';
import { permissions } from 'utils/permissions/permissions';

const init = () => ({
	config: {
		notification_icons: {
			NEW_SERVICE: 'elementPlus',
			PAYMENT_SUCCESSFUL: 'paymentSuccess',
			PAYMENT_STATUS_UPDATE: 'bank',
			ACCOUNT_CHANGE: 'star',
			SERVICE_DISCONNECTED: 'complaint',
			INVOICE_BREAKUP_REPORT_FAILED_REPORT_GENERATION: 'warningBlack',
			INVOICE_BREAKUP_REPORT_SUCCESSFUL_REPORT_GENERATION: 'fileExport',
			INVOICE_BREAKUP_REPORT_ONE_TIME_REPORT_SUBMISSION: 'tickBlackCircle',
			INVOICE_BREAKUP_REPORT_RECURRING_REPORT_SUBMISSION: 'fileSubmitRecurr',
			INVOICE_BREAKUP_REPORT_CANCEL_RECURRING_REPORT: 'fileCross',
			INVOICE_BREAKUP_REPORT_UPDATE_RECURRING_REPORT: 'fileUpload',
			INVOICE_BREAKUP_REPORT_FAILED_WITHOUT_INCIDENT_REPORT_GENERATION: 'warningBlack',
			PROFILE_PLAN_REPORT_FAILED_REPORT_GENERATION: 'warningBlack',
			PROFILE_PLAN_REPORT_SUCCESSFUL_REPORT_GENERATION: 'fileExport',
			PROFILE_PLAN_REPORT_ONE_TIME_REPORT_SUBMISSION: 'tickBlackCircle',
			PROFILE_PLAN_REPORT_RECURRING_REPORT_SUBMISSION: 'fileSubmitRecurr',
			PROFILE_PLAN_REPORT_CANCEL_RECURRING_REPORT: 'fileCross',
			PROFILE_PLAN_REPORT_UPDATE_RECURRING_REPORT: 'fileUpload',
			PROFILE_PLAN_REPORT_FAILED_WITHOUT_INCIDENT_REPORT_GENERATION: 'warningBlack',
		},
	},
	permissions: { ...permissions },
	domain: {},
});

const reducer = {
	[setWCMAppConfig](state: any, action: setWCMAppConfigAction) {
		return {
			...state,
			config: action.payload.appConfig,
			permissions: { ...state.permissions, ...action.payload.permissions },
			domain: action.payload.domain,
		};
	},
};

export default immerHandleActions(reducer, init());
